import React from 'react';
import { DirectionalHint, IconButton } from 'office-ui-fabric-react';
import { ActionIconName } from '../../../Icons';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const FilterMenuContainer = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    style: {
      minWidth: '100%',
      minHeight: '100%'
    },
    children: children
  });
};
export const FilterTools = _ref2 => {
  var _headerGroup$filterVa;
  let {
    headerGroup
  } = _ref2;
  const menuProps = {
    items: [{
      key: 'filter',
      onClick: e => {
        e === null || e === void 0 || e.preventDefault();
        e === null || e === void 0 || e.stopPropagation();
      }
    }],
    directionalHint: DirectionalHint.bottomLeftEdge,
    onRenderMenuList: () => /*#__PURE__*/_jsx(FilterMenuContainer, {
      children: headerGroup.render('Filter')
    })
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: headerGroup.canFilter && /*#__PURE__*/_jsx(IconButton, {
      menuProps: menuProps,
      iconProps: {
        iconName: headerGroup.filterValue ? ActionIconName.FilterOn : ActionIconName.FilterOff
      },
      title: "Filtering ".concat(headerGroup.id, ": ").concat((_headerGroup$filterVa = headerGroup.filterValue) !== null && _headerGroup$filterVa !== void 0 ? _headerGroup$filterVa : ''),
      ariaLabel: "Filter"
    })
  });
};